import Vue from 'vue';
import VueRouter from 'vue-router';

import { canNavigate } from '@/libs/acl/routeProtection'
import { isUserLoggedIn } from '@/auth/utils'

Vue.use(VueRouter);

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior() {
    return { x: 0, y: 0 }
  },
  routes: [
    {
      path: '/',
      name: 'home',
      component: () => import('@/views/Home.vue'),
      meta: {
        pageTitle: 'Home',
        breadcrumb: [
          {
            text: 'Home',
            active: true,
          },
        ],
      },
    },
    {
      path: '/grupo',
      name: 'grupo',
      component: () => import('@/views/Grupo/Grupo.vue'),
      meta: {
        pageTitle: 'Grupo',
        breadcrumb: [
          {
            text: 'Grupo',
            active: true,
          },
        ],
      },
    },
    {
      path: '/grupo/editar/:alias',
      name: 'grupo-edit',
      component: () => import('@/views/Grupo/Grupo-Edit.vue'),
      meta: {
        pageTitle: 'Grupo',
        breadcrumb: [
          {
            text: 'Editar Grupo',
            active: true,
          },
        ],
        navActiveLink: 'grupo',
      },
    },
    {
      path: '/grupo/adicionar',
      name: 'grupo-add',
      component: () => import('@/views/Grupo/Grupo-Add.vue'),
      meta: {
        pageTitle: 'Grupo',
        breadcrumb: [
          {
            text: 'Adicionar Grupo',
            active: true,
          },
        ],
        navActiveLink: 'grupo'
      },
    },
    {
      path: '/grupo/atualizar/:alias',
      name: 'grupo-atualizar',
      component: () => import('@/views/Upload/Grupo.vue'),
      meta: {
        pageTitle: 'Grupo',
        breadcrumb: [
          {
            text: 'Atualizar Grupo',
            active: true,
          },
        ],
        navActiveLink: 'grupo'
      },
    },
    {
      path: '/usina',
      name: 'usina',
      component: () => import('@/views/Usinas/Usinas.vue'),
      meta: {
        pageTitle: 'Usina',
        breadcrumb: [
          {
            text: 'Usina',
            active: true,
          },
        ],
      },
    },
    {
      path: '/usina/editar/:alias',
      name: 'usina-edit',
      component: () => import('@/views/Usinas/Usinas-Edit.vue'),
      meta: {
        pageTitle: 'Usina',
        breadcrumb: [
          {
            text: 'Editar Usina',
            active: true,
          },
        ],
        navActiveLink: 'usina',
      },
    },
    {
      path: '/usina/editar/info/:id',
      name: 'usina-edit-info',
      component: () => import('@/views/Usinas/Usinas-Edit-Info.vue'),
      meta: {
        pageTitle: 'Usina',
        breadcrumb: [
          {
            text: 'Editar Informações',
            active: true,
          },
        ],
        navActiveLink: 'usina',
      },
    },
    {
      path: '/usina/adicionar',
      name: 'usina-add',
      component: () => import('@/views/Usinas/Usinas-Add.vue'),
      meta: {
        pageTitle: 'Usina',
        breadcrumb: [
          {
            text: 'Adicionar Usina',
            active: true,
          },
        ],
        navActiveLink: 'usina'
      },
    },
    {
      path: '/usina/atualizar/:alias',
      name: 'usina-atualizar',
      component: () => import('@/views/Upload/Usina.vue'),
      meta: {
        pageTitle: 'Usina',
        breadcrumb: [
          {
            text: 'Atualizar Usina',
            active: true,
          },
        ],
        navActiveLink: 'usina',
      },
    },
    {
      path: '/usina/atualizar/info/:id',
      name: 'usina-atualizar-info',
      component: () => import('@/views/Upload/UsinaInfo.vue'),
      meta: {
        pageTitle: 'Usina',
        breadcrumb: [
          {
            text: 'Atualizar Informações da Usina',
            active: true,
          },
        ],
        navActiveLink: 'usina',
      },
    },
    {
      path: '/upload',
      name: 'upload',
      component: () => import('@/views/Upload/Upload.vue'),
      meta: {
        pageTitle: 'Upload',
        breadcrumb: [
          {
            text: 'Upload',
            active: true,
          },
        ],
      },
    },
    {
      path: '/login',
      name: 'login',
      component: () => import('@/views/Login.vue'),
      meta: {
        layout: 'full',
        resource: 'Auth',
        redirectIfLoggedIn: true,
      },
    },
    {
      path: '/error-404',
      name: 'error-404',
      component: () => import('@/views/error/Error404.vue'),
      meta: {
        layout: 'full',
      },
    },
    {
      path: '*',
      redirect: 'error-404',
    },
  ],
});

router.beforeEach((to, _, next) => {
  const isLoggedIn = isUserLoggedIn();

  if (!canNavigate(to)) {
    // Redirecionar para login se não estiver logado
    if (!isLoggedIn) return next({ name: 'login' });
  }

  // Redirect if logged in
  if (to.meta.redirectIfLoggedIn && isLoggedIn) {
    return next({ name: 'home' });
  }

  return next();
});

// ? For splash screen
// Remove afterEach hook if you are not using splash screen
router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById('loading-bg')
  if (appLoading) {
    appLoading.style.display = 'none';
  }
})

export default router;